export const solutionsData = [
  {
    name: 'jobPosting',
    slug: 'jobPosting',
    tooltip:
      'Match roles with the right people using optimised targeting, data-driven insights, and enhanced screening.',
  },
  {
    name: 'optimisedApply',
    slug: 'optimisedApply',
    tooltip:
      'Make it easier to manage your applications from SEEK by connecting our Apply process with your software.',
  },
  {
    name: 'applyWithSeeK',
    slug: 'applyWithSeek',
    tooltip:
      'Using any device, candidates can use their SEEK Profiles to prefill an application when on your site.',
  },
];
